import { render } from "./SleepContentHeader.vue?vue&type=template&id=5121af56&scoped=true"
import script from "./SleepContentHeader.vue?vue&type=script&lang=js"
export * from "./SleepContentHeader.vue?vue&type=script&lang=js"

import "./SleepContentHeader.vue?vue&type=style&index=0&id=5121af56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5121af56"]])

export default __exports__